import { render, staticRenderFns } from "./DeactivateAccount.vue?vue&type=template&id=05df8a98&scoped=true"
import script from "./DeactivateAccount.vue?vue&type=script&lang=js"
export * from "./DeactivateAccount.vue?vue&type=script&lang=js"
import style0 from "./DeactivateAccount.vue?vue&type=style&index=0&id=05df8a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df8a98",
  null
  
)

export default component.exports